// Imports
import { Img, Container, ComponentWrapper } from "@/components";
import { imageContainerStyles } from "@/lib/utils";

// Image
export function Image({ type, image, height = "md", width = "lg" }) {
  // Render

  const contain = image?.contain_image;

  return (
    <ComponentWrapper type={type}>
      <Container>
        <div
          className={imageContainerStyles({
            height: contain ? "none" : height,
            width,
          })}
        >
          <Img data={image} sizes="(max-width: 1024px) 100vw, 1600px" fill />
        </div>
      </Container>
    </ComponentWrapper>
  );
}
